import clsx from "clsx";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectServiceData } from "../../../../redux/crm/selectors";
import css from "../SelectTime/SelectTime.module.css";
import { format, isBefore, isSameDay, startOfDay } from "date-fns";

export default function SelectTime({
  postId,
  recordId,
  setDatesArray,
  setBooking,
  pickedDate,
  car,
  mechanicId,
  chosenTime,
  setChosenTime,
  setInitialChosenTime,
  initialChosenTime,
}) {
  const { availability } = useSelector(selectServiceData);
  // console.log("pickedDate", pickedDate);
  // const recordById = useSelector(selectRecordById);

  // console.log("car", car);
  // console.log("recordId", recordId);
  // console.log("availability", availability);
  // console.log("mechanicId", mechanicId);
  console.log("initialChosenTime", initialChosenTime);

  const initialChosenDate = initialChosenTime?.find(item =>
    isSameDay(item.appointment_date, pickedDate)
  );

  const initiallyChosenHours = initialChosenDate?.times || [];

  const onTimeBtnClick = time => {
    setChosenTime(prevValues => {
      console.log("prevValues", prevValues);
      const existingDate = prevValues.find(item =>
        isSameDay(item.appointment_date, pickedDate)
      );

      console.log("existingDate", existingDate);

      if (existingDate) {
        let updatedTimes = existingDate.times.includes(time)
          ? existingDate.times.filter(t => t !== time)
          : [...existingDate.times, time];

        updatedTimes = updatedTimes.sort();

        return prevValues.map(item =>
          isSameDay(item.appointment_date, pickedDate)
            ? { ...item, times: updatedTimes } // навіть якщо []
            : item
        );
      } else {
        return [
          ...prevValues,
          { appointment_date: pickedDate, times: [time].sort() },
        ];
      }
    });
  };

  useEffect(() => {
    if (!chosenTime?.length) {
      setDatesArray([]);
      setBooking([]);
      return;
    }

    const dataForBooking = chosenTime.map(({ appointment_date, times }) => ({
      appointment_date: format(appointment_date, "yyyy-MM-dd"),
      times,
    }));

    const datesArray = chosenTime.map(({ appointment_date, times }) => ({
      appointment_date: format(appointment_date, "yyyy-MM-dd"),
      start_time: times[0],
      end_time: times[times.length - 1],
    }));

    setDatesArray(datesArray);
    setBooking(dataForBooking);
  }, [chosenTime, setDatesArray, setBooking]);

  console.log("chosenTime", chosenTime);

  const isChosenDate = chosenTime?.find(item => {
    // return item.appointment_date === pickedDate;
    return isSameDay(item.appointment_date, pickedDate);
  });
  const chosenHours = isChosenDate?.times;

  // console.log("chosenHours", chosenHours);

  if (!postId) {
    return;
  }

  const availableHours = availability?.find(
    item => Number(item.post_id) === Number(postId)
  );

  const isMechanicBusyAtTime = (availability, time, mechanicId) => {
    if (!availability || !mechanicId) return false;

    return availability.some(post => {
      const hourData = post.hours?.[time];
      return hourData?.status === 1 && hourData?.mechanic_id === mechanicId;
    });
  };

  return (
    <>
      {availableHours?.hours &&
        Object.entries(availableHours.hours)
          .sort(([a], [b]) => {
            const [hoursA] = a.split(":").map(Number);
            const [hoursB] = b.split(":").map(Number);
            return hoursA - hoursB;
          })
          .map(([hour, value], index) => {
            const [hours, minutes] = hour.split(":");
            const transformedHours = hours.padStart(2, 0);
            const transformedTime = `${transformedHours}:${minutes}`;

            const isBusy = value.status === 1;
            const isChosen = chosenHours?.includes(transformedTime);

            const today = startOfDay(new Date());

            const isToday = isSameDay(pickedDate, today);
            const isPastDay = isBefore(pickedDate, today);

            const isPastHour = isToday && Number(hours) < new Date().getHours();

            const isMechanicBusy = isMechanicBusyAtTime(
              availability,
              hour,
              mechanicId
            );

            const isCurrentBookingHours =
              initiallyChosenHours.includes(transformedTime);

            const isDisabled =
              isPastDay ||
              isPastHour ||
              (!isCurrentBookingHours && (isBusy || isMechanicBusy));

            return (
              <button
                key={index}
                type="button"
                className={clsx(
                  css.timeBtn,
                  css.timeBtnFree,
                  isChosen && css.timeBtnChosen,
                  isDisabled && !isChosen && css.timeBtnDisabled
                )}
                onClick={() => onTimeBtnClick(transformedTime, value)}
                disabled={isDisabled}
              >
                {transformedTime}
              </button>
            );
          })}
    </>
  );
}
